import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false
  };

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out"
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: ""
    });
  };

  render() {
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container>
              <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                <img
                  alt="..."
                  src={require("assets/img/nugazLogoNavbar.png")}
                />
              </NavbarBrand>
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="..."
                          src={require("assets/img/nugaz-logo-coul.png")}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                <Nav className="navbar-nav-hover align-items-lg-center" navbar>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                     
                      <Button
                      className="btn-neutral btn-icon"
                      color="default"
                      
                      target="_blank"
                    >
                      <span className="nav-link-inner--text ml-1">
                        Parcourir
                      </span>
                    </Button>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-xl">
                      <div className="dropdown-menu-inner">

                        <Media
                          className="d-flex align-items-center"
                          target="_blank"
                        >
                          <div className="icon icon-shape bg-gradient-primary rounded-circle text-white">
                            <i className="ni ni-spaceship" />
                          </div>
                          <Media body className="ml-3">
                          <DropdownItem to="/service" tag={Link}>
                            <h6 className="heading text-primary mb-md-1">
                              Service
                            </h6>
                            <p className="description d-none d-md-inline-block mb-0">
                             Apprenez-en plus sur les services que nous offrons
                            </p>
                      </DropdownItem>
                          </Media>
                        </Media>
                      
                        <Media
                          className="d-flex align-items-center"
                          target="_blank"
                        >
                          <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                            <i className="ni ni-world" />
                          </div>
                          <Media body className="ml-3">
                          <DropdownItem to="/gaz-naturel" tag={Link}>
                            <h6 className="heading text-primary mb-md-1">
                              Le gaz naturel
                            </h6>
                            <p className="description d-none d-md-inline-block mb-0">
                              Apprenez-en plus sur le gaz naturel
                            </p>
                      </DropdownItem>
                          </Media>
                        </Media>

                        <Media
                          className="d-flex align-items-center mr-2"
                          target="_blank"
                        >
                          <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                            <i className="ni ni-circle-08" />
                          </div>
                        <DropdownItem to="/contact-page" tag={Link}>
                          <Media body className="ml-3">

                            <h5 className="heading text-warning mb-md-1">
                              Contact
                            </h5>
                            <p className="description d-none d-md-inline-block mb-0">
                              Visitez notre équipe
                            </p>
                          </Media>
                      </DropdownItem>
                        </Media>

                        
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                
                </Nav>
                <Nav className="align-items-lg-center ml-lg-auto" navbar>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.facebook.com/SolutionNugaz"
                      id="tooltip333589074"
                      target="_blank"
                    >
                      <i className="fa fa-facebook-square" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Facebook
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip333589074">
                      Écrivez-nous sur facebbok
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.linkedin.com/company/solution-n%C3%BCgaz/"
                      id="tooltip356693867"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Linkedin
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip356693867">
                      Suivez-nous sur linkedin
                    </UncontrolledTooltip>
                  </NavItem>    
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default DemoNavbar;
